import { snakeToTitleCase } from '@domain-group/javascript-utils'

import { Form, ListItem } from '@domain-group/suit-theme'

import { notificationTypes } from '@functions/notification'

import NotificationItem, { ToggleItem } from './NotificationItem'

interface NotificationCategoryProps {
  callbacks: {
    updateNotificationOptions: (key: string) => void,
  },
  category: string,
  disabledNotifications: string[],
  notificationType: Partial<typeof notificationTypes>,
  isBrandCustomProfile: boolean,
  systemDefaultEnabled?: boolean,
}

const NotificationCategory = (props: NotificationCategoryProps) => {
  const {
    callbacks, category, disabledNotifications, notificationType, isBrandCustomProfile, systemDefaultEnabled,
  } = props

  return (
    <ListItem
      flexDirection="column"
      boxProps={{
        borderBottom: '1px dashed',
        fontSize: 'small',
        marginBottom: 'large',
      }}
      disableHover
    >
      {/*
       // @ts-expect-error TS2741 */}
      <Form.Field
        label={snakeToTitleCase(category)}
        labelProps={{ style: { color: 'bodyFontLightColor', marginBottom: '16px' } }}
      />

      {/*
       // @ts-expect-error TS2339 */}
      {notificationType.map(((toggleItem: ToggleItem) => (
        <NotificationItem
          callbacks={callbacks}
          disabledNotifications={disabledNotifications}
          key={toggleItem.key}
          toggleItem={toggleItem}
          isBrandCustomProfile={isBrandCustomProfile}
          systemDefaultEnabled={systemDefaultEnabled}
        />
      )))}
    </ListItem>
  )
}

export default NotificationCategory
